import { useEffect } from 'react';
import { io, type Socket } from 'socket.io-client';

let socket: Socket | null = null;

/** Ein einziger, wiederverwendeter Socket.IO-Client für die gesamte App - verbindet cookie-authentifiziert (siehe `backend/src/realtime/io.ts`), kein separates Login. */
function getSocket(): Socket {
  socket ??= io({ path: '/socket.io', withCredentials: true, autoConnect: true });
  return socket;
}

/** Abonniert `event` für die Lebensdauer der Komponente. */
export function useSocketEvent<T>(event: string, handler: (payload: T) => void): void {
  useEffect(() => {
    const s = getSocket();
    s.on(event, handler);
    return () => {
      s.off(event, handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);
}
